<template>
  <div>
    <!-- Profit Loss Exp Invoice Summary Section Start -->
    <div></div>
    <b-button
      v-if="!isIcon && allModuleId > 0"
      class="mb-1 mt-1"
      @click="showPLInvExpModal(allModuleId)"
      size="xs"
      style="font-size: 0.675rem"
      >Inv Exp Summary</b-button
    >
    <b-button v-else-if="isIcon && allModuleId > 0"
        @click="showPLInvExpModal(allModuleId)" 
        size="sm" 
        variant="outline-secondary" 
        class="mr-1 btn-action"
        v-b-tooltip.hover title="Inv/Exp Summary"
    >
        <i :class="iconClass || 'fa fa-list-alt'"></i>
    </b-button>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="PLInvExp-modal"
      hide-footer
      :title="Page_title"
    >
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="12">
          <b-button
            class="pull-right mb-1"
            v-if="PLInvExpList.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReports('getJobExpInvDetails', 'Export As Excel')"
            size="sm"
            variant="warning"
          >
            {{ ExcelBtnName }}
            <b-spinner
              v-if="ExcelBtnName != 'Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>
          <b-button
            class="pull-right mb-1"
            :disabled="ExcelBtnNameAll != 'All Split Export As Excel' ? true : false"
            @click="getReportsAll('getJobExpInvAllDetails', 'All Split Export As Excel')"
            size="sm"
            variant="warning"
          >
            {{ ExcelBtnNameAll }}
            <b-spinner
              v-if="ExcelBtnNameAll != 'All Split Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>
          <b-table
            show-empty
            stacked="md"
            :items="PLInvExpList"
            :fields="PLInvExpfields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="inv_type" slot-scope="row1">
              <span>Inv Type : {{ row1.item.inv_type }}<br /></span>
              <span>Inv Created : {{ row1.item.inv_create_date }}<br /></span>
              <span>Inv Updated : {{ row1.item.inv_update_date }}</span>
              <div
                :id="'row' + row1.item.inv_id"
                v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
              >
                <md-switch
                  :id="'approval' + row1.item.inv_id"
                  name="approval"
                  class="md-primary"
                  :value="row1.item.inv_is_active == 0 ? true : false"
                  @change="isRemoveItemSplit(row1.item)"
                >
                  <h6>
                    <br />
                    <b-badge
                      :variant="row1.item.inv_is_active == 0 ? 'success' : 'danger'"
                      >{{ row1.item.inv_is_active == 0 ? "Remove" : "Pending" }}</b-badge
                    >
                  </h6>
                </md-switch>
              </div>
            </template>
          </b-table>
          <table
            class="table table-sm table-bordered mt-2"
            v-if="PLInvExpList.length > 0"
          >
            <tbody style="background: white">
              <tr>
                <td colspan="4" style="text-align: center; color: red">
                  <b>Total : </b>
                </td>
                <td colspan="2" style="text-align: center; color: red">
                  <b>PL : {{ PLAMT }}</b>
                </td>
                <td style="text-align: center; color: red">
                  <b>Exp : {{ PLExpAMT }}</b>
                </td>
                <td style="text-align: center; color: red">
                  <b>Inv : {{ PLInvAMT }}</b>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <h5>
              <div>
                <b-pagination
                  limit="25"
                  align="center"
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="PLInvExpList.length"
                  @change="onPageChange($event)"
                ></b-pagination>
              </div>
            </h5>
          </div>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button class="mt-3" variant="outline-danger" @click="hidePLInvExpModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>
  </div>

  <!-- Profit Loss Inv Expense Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import CustomLoader from "../common/customLoader.vue";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_JOBID: {
      type: String,
      default: "",
    },
    PMC_JOBNO: {
      type: String,
      default: "",
    },
    PMC_JOBDATE: {
      type: String,
      default: "",
    },
    PMC_JOBTYPE: {
      type: String,
      default: "",
    },
    PMC_AgentType: {
      type: String,
      default: "",
    },
    PMC_Client: {
      type: String,
      default: "",
    },
    PMC_Sline: {
      type: String,
      default: "",
    },
    isIcon: {
        type: Boolean,
        default: false
    },
    iconClass: {
        type: String,
        default: ''
    }
  },
  beforeMount() {
    if (this.PMC_JOBID) {
      // this.getPLInvExp();
    }
  },
  mounted() {},

  data() {
    return {
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      Page_title: this.PMC_title,
      totalRows: 0,
      currentPage: 1,
      perPage: 300,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      PLInvExpfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "inv_type",
          mainkey: "inv_type",
          label: "Voucher Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "inv_no",
          mainkey: "inv_no",
          label: "Voucher No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "inv_date",
          mainkey: "inv_date",
          label: "Voucher Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "customer_name",
          mainkey: "customer_name",
          label: "Customer Name",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "particulars",
          mainkey: "particulars",
          label: "Particulars",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "exp_AMT",
          mainkey: "exp_AMT",
          label: "Expense",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },

        {
          key: "inv_AMT",
          mainkey: "inv_AMT",
          label: "Income",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
      ],
      PLInvExpList: [],
      PLInvAMT: 0,
      PLExpAMT: 0,
      PLAMT: 0,
      allModuleId: this.PMC_JOBID,
      isLoading: false,
      ExcelBtnName: "Export As Excel",
      ExcelBtnNameAll: "All Split Export As Excel",
      docURL: URL_BASE_DOC,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getPLInvExp("Normal");
      },
      deep: true,
    },
  },
  methods: {
    onClose() {
    },
    isRemoveItemSplit(item) {
      let payload = {
        inv_id: item.inv_id,
        inv_exp_type: item.inv_exp_type,
        inv_delete: item.inv_delete,
        inv_is_active: item.inv_is_active,
        itemCode: "updateInvoiceExpense",
      };
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.find == 1 && data.flag == true) {
            this.alert.content = data.MSG;
            this.$refs["addPop"].open();
            this.getPLInvExp("Normal");
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log("Catch on getSubItemList Error: ", error);
        });
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getPLInvExp("Excell");
    },
    getPLInvExp(type) {
      this.PLInvAMT = 0;
      this.PLExpAMT = 0;
      this.PLAMT = 0;
      this.PLInvExpList = [];
      let payload = {};
      if (this.PMC_JOBID) {
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getJobExpInvDetails",
          allModuleId: this.PMC_JOBID,
          type: type,
        };

        CommonService.getAllExpenseList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data) {
              if (type == "Excell") {
                if (data.PLInvExpList.length > 0) {
                  this.PLInvExpList = data.PLInvExpList;
                  this.PLInvAMT = data.PLInvAMT;
                  this.PLExpAMT = data.PLExpAMT;
                  this.PLAMT = data.PLAMT;
                }
                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.PLInvExpList.length > 0) {
                  this.PLInvExpList = data.PLInvExpList;
                  this.PLInvAMT = data.PLInvAMT;
                  this.PLExpAMT = data.PLExpAMT;
                  this.PLAMT = data.PLAMT;
                }
              }
            }
             this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on PLInvExpList Error: ", error);
          });
      }
    },

    getReportsAll(id, btnName) {
      this.ExcelBtnNameAll = "Downloading Please Wait .....";
      this.getPLInvExpAll("Excell");
    },
    getPLInvExpAll(type) {
      this.isLoading = true;
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getJobExpInvAllDetails",
        allModuleId: this.PMC_JOBID,
        type: type,
      };

      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.PLInvExpList.length > 0) {
                this.ExcelBtnNameAll = "All Split Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              }
            }
          }
        this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPLInvExpAll Error: ", error);
        });
    },

    showPLInvExpModal(allModuleId) {
      this.PLInvExpList = [];
      this.$refs["PLInvExp-modal"].show();
      this.getPLInvExp("Normal");
     // this.isLoading = false;
    },
    hidePLInvExpModal() {
      this.PLInvExpList = [];
      this.$refs["PLInvExp-modal"].hide();
// this.isLoading = false;
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// moduleBasedInvExpSummary.vue?525df3be